import { useState } from "react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import Modal from "../Modal"
import Button from "../../atoms/Button"
import RcmpAlert from "../../atoms/Alert"

export default function RcmpModalAdd(props) {
  const {
    isOpen,
    children,
    buttonCancelText,
    buttonSaveText,
    fnHandleCancel,
    handleSubmit,
    fnCreate,
    title,
    fnHandleConfirm,
    buttonType,
    size,
    disabledSaveButton,
    oButtonCancelProps,
    oButtonSaveProps,
    cAlertMessage,
    cAlertType,
    bIsInfo = false,
    showFooter = true,
    onlyCancel = false,
    customWidth,
  } = props
  const [bLoading, setFnBLoading] = useState(false)

  async function fnOnSubmitData(e) {
    e.preventDefault()
    e.stopPropagation()
    setFnBLoading(true)
    try {
      await handleSubmit(fnCreate)(e)
      setFnBLoading(false)
    } catch (err) {
      setFnBLoading(false)
    }
  }

  async function fnOnConfirm(e) {
    if (typeof fnHandleConfirm !== "function") return
    e.preventDefault()
    e.stopPropagation()
    setFnBLoading(true)
    try {
      await fnHandleConfirm(e)
      setFnBLoading(false)
    } catch (err) {
      setFnBLoading(false)
    }
  }

  const disabled = disabledSaveButton || false
  const cModalSize = size || "lg"

  return (
    <Modal customWidth={customWidth} isOpen={isOpen} size={cModalSize} onRequestClose={fnHandleCancel}>
      <Modal.Header onClose={fnHandleCancel}>{title}</Modal.Header>
      <form
        onSubmit={fnOnSubmitData}
        className={`${styles.modalContent} ${!showFooter ? styles.noFooter : ""}`}
      >
        <Modal.Content size={cModalSize}>
          <RcmpAlert cType={cAlertType || "error"} bIsOpen={cAlertMessage?.length}>
            {cAlertMessage}
          </RcmpAlert>
          <div className={styles.modalContainer}>{children}</div>
        </Modal.Content>
        {onlyCancel && (
          <Modal.Footer size={cModalSize}>
            <div className={styles.onlyCancel}>
              <Button
                type="button"
                variant="outline"
                onClick={(e) => {
                  e.preventDefault()
                  fnHandleCancel()
                }}
                disabled={bLoading}
                {...oButtonCancelProps}
              >
                {buttonCancelText || intl.get("cancel")}
              </Button>
            </div>
          </Modal.Footer>
        )}
        {showFooter && !onlyCancel && (
          <Modal.Footer size={cModalSize}>
            <div className={styles.buttonsContainer}>
              <Button
                type="button"
                variant="outline"
                onClick={(e) => {
                  e.preventDefault()
                  fnHandleCancel()
                }}
                disabled={bLoading}
                {...oButtonCancelProps}
              >
                {buttonCancelText || intl.get("cancel")}
              </Button>
              <Button
                onClick={fnOnConfirm}
                type={buttonType || "submit"}
                disabled={bLoading || disabled}
                isLoading={bLoading}
                className={bIsInfo && styles.infoButtonStyle}
                {...oButtonSaveProps}
              >
                {buttonSaveText || intl.get("save")}
              </Button>
            </div>
          </Modal.Footer>
        )}
      </form>
    </Modal>
  )
}
